exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".report[data-v-da46c258]{width:90%;border:1px solid #ddd;text-align:center;font-size:13px}.report .header[data-v-da46c258]{font-size:16px;padding:20px 0}.report .body[data-v-da46c258]{border-bottom:1px solid #ddd}.report .body .td[data-v-da46c258]{border:1px solid #ddd;border-left:none;border-bottom:none;padding:2px 0;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.report .body .td.no-br[data-v-da46c258]{border-right:none}.report .body .td.no-bt[data-v-da46c258]{border-top:none}.report .body .td.bg[data-v-da46c258]{background-color:#f3b084}.report .footer[data-v-da46c258]{padding:20px 0;text-align:left}.no-data[data-v-da46c258]{padding:20px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-da46c258","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./vue/views/report/dinner.vue
// module id = 476
// module chunks = 0